import authSaga from 'features/auth/redux/authSaga';
import layoutSaga from 'features/website-layout/redux/layoutSaga';
import { all } from 'redux-saga/effects';

export default function* rootSaga() {
  yield all([authSaga(), layoutSaga()]);
}
